module.exports = __webpack_public_path__ + "img/addlogo.51b15021.svg";